import { render } from "./AppSearch.vue?vue&type=template&id=0d0809e7&scoped=true"
import script from "./AppSearch.vue?vue&type=script&lang=js"
export * from "./AppSearch.vue?vue&type=script&lang=js"

import "./AppSearch.vue?vue&type=style&index=0&id=0d0809e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0809e7"]])

export default __exports__